module.exports = __webpack_public_path__ + "static/media/eco-agriculture.08c53932.svg";